module.exports = __webpack_public_path__ + "1539d9f27427530e8264d1ddb97b4e11.svg";